<template>
    <b-card class="merge-card mb-4" body-class="d-flex justify-content-between flex-column">
        <template v-slot:header>
            <span class="mb-0 h6 float-left text-dark">
            <i class="mr-1" :class="main_icon"></i> Conversion 2 Trends</span>
        </template>

        <Conversion2TrendsWidget
                :main_icon="main_icon"
                :load_url="load_url"
                :title="title">
        </Conversion2TrendsWidget>

    </b-card>

</template>

<script>
    import Conversion2TrendsWidget from '../../widgets/Conversion2Trends.vue';
    export default {
        name: 'Conversion2Trends',
        components: {Conversion2TrendsWidget},
        data() {
            return {
                main_icon: 'fa-duotone fa-chart-bar',
                title: 'Conversion 2 Trends',
                load_url: '/dashboards/conversion2',
            };
        },
    };
</script>

<style scoped>

</style>